import { Link } from "react-router-dom";
import styled from "styled-components";

export const Item = styled("div")(() => ({
  marginBottom: 16,
}));

export const ItemTitle = styled("h3")(({ theme }) => ({
  marginBottom: 4,
  fontSize: 15,
  fontWeight: 600,
  lineHeight: "24px",
  color: theme.palette.text?.primary,
}));

export const Cta = styled("div")(() => ({
  marginTop: 40,
  textAlign: "center",
}));

export const CtaButton = styled(Link)(({ theme }) => ({
  display: "inline-block",
  marginTop: 8,
  padding: "12px 24px",
  borderRadius: 8,
  fontSize: 15,
  fontWeight: 600,
  lineHeight: "24px",
  color: "#fff",
  backgroundColor: theme.palette.primary?.main,
  textDecoration: "none",
}));
